import { API_TYPE } from '@umu/umu-fetch';

export const HomeworkAPI = {
    GET_GESTURE_LIST: {
        url: `/uapi/v1/gesture-practice/element-detail`,
        type: API_TYPE.POST,
    },
    GET_GESTURE_DETAIL: {
        url: `/uapi/v1/gesture-practice`,
        type: API_TYPE.GET,
    },
    // 屏蔽
    POST_SWITCH_HOMEWORK_SHIELD: {
        url: `/uapi/v1/homework/shield`,
        type: API_TYPE.POST,
    },
    // 设为优秀作业
    POST_SWITCH_HOMEWORK_EXCELLENT: {
        url: `/uapi/v1/homework/set-excellent`,
        type: API_TYPE.POST,
    },
    POST_SET_SPEAKER: {
        url: `/uapi/v1/homework/set-speaker`,
        type: API_TYPE.POST,
    },
    GET_SPEAKER_NAME: {
        url: `/uapi/v1/homework/get-speaker-name`,
        type: API_TYPE.GET,
    },
    GET_AI_EXPRESSIVE_EVAL_TEMP: {
        url: `/uapi/v1/homework/ai-eval-template`,
        type: API_TYPE.GET,
    },
    POST_SET_SPEAKER_NAME: {
        url: `/uapi/v1/homework/set-speaker-name`,
        type: API_TYPE.POST,
    },
    SAVE_HOMEWORK_KEYWORDS: {
        url: `/uapi/v1/keywords/save`,
        type: API_TYPE.POST,
    },
    GET_HOMEWORK_KEYWORDS: {
        url: `/uapi/v1/keywords/get`,
        type: API_TYPE.GET,
    },
    GET_MY_HOMEWORK: {
        url: '/uapi/v1/homework/my',
        type: API_TYPE.GET,
    }
};
